import http from "infra/http";
import { useInfiniteQuery } from "react-query";
import { ListagemMensagemResponse, MensagemFiltro } from "../typings";

function useMensagens(filtro: MensagemFiltro, enabled = true) {
  return useInfiniteQuery(
    [`/v1/mensagem`, filtro],
    async ({ pageParam }) => {
      const { data } = await http.get<ListagemMensagemResponse>(
        `/v1/mensagem`,
        {
          params: {
            ...filtro,
            page: pageParam ?? 1,
          },
        }
      );
      return data;
    },
    {
      getNextPageParam: (lastPage) =>
        lastPage.meta.currentPage === lastPage.meta.totalPages
          ? undefined
          : lastPage.meta.currentPage + 1,
      enabled,
    }
  );
}

export default useMensagens;
